// import SimpleBar from 'simplebar';
// import select2 from 'select2';
import searchBar from '../exports/selectFilters';
import {generateSlider, toggleSelect} from '../exports/events';
import {extraFeatSettings, relatedGamesSettings} from '../exports/sliderSettings';
import {promptFileDownload} from './clientHub';
import {formatBytes, sumArray} from '../exports/formatBytes';

const clientHubLogic = () => {
  /*
 * SELECTORS
 */

  const global_selectors = {
    $mobileSelectors: $('.mobile-nav, body,#header, .mobile-burger'),
    $userDropdownBtn: $('#header .profile'),
    $userDropdown: $('#header + .user-dropdown'),
    $header: $('#header'),
    $bodyGlobal: $('.overlay.user, body'),
    $jsOpenDemoPopBtn: $('.js-play-game-demo'),
    $demoPopIframe: $('.game-demo-pop iframe'),
    $popUpElements: $('body,.overlay.game-demo,.custom-pop.game-demo-pop'),
    $passIcon: $('.client-form-row.password .icon'),
    $singleGameVideoBtn: $('.jackpots-single.game-single .js-play'),
    $singleJackpotVideoBtn: $('.jackpots-single-page .js-play'),
    $singleJackpotVideoParent: $('.jackpot-video'),
    $singleJackpotVideoIframe: $('.jackpot-video iframe'),
    $fileOverlay: $('.custom-file-overlay'),
    $fileOverlayNum: $('.custom-file-overlay .num-items'),
    $fileOverlayBtn: $('.custom-file-overlay a'),
    $customCheckboxInput: $('.custom-checkbox input'),
    $filesPopBtn: $('.js-files-pop-btn'),
    $filesPop: $('.custom-pop.download-media'),
    $filesPopInputs: $('.download-media .listing-wrapper input'),
    $filesPopCheckAllBtn: $('#all_data'),
    $filesPopDownloadBtn: $('.download-media .downloadable-file'),
    $roadmapSlider: '.roadmap-page .images-listing',
    $subMega: $('.sub-el.sub-sub'),
    $jsMedia: $('.js-d-media'),
    $userInfoPopBtn: $('.js-user-pop-info'),
    $userNewPopBtn: $('.js-user-pop-profile'),
    $userNewPasspBtn: $('.js-user-pop-password'),
    $userInfoPop: $('.user-pop--info'),
    $userNewPop: $('.user-pop--profile'),
    $userNewPass: $('.user-pop--password'),
    $relatedSlider: '.related-swiper-mobile',
    $globalOverlay: $('.overlay'),
    $bodyAndOverlay: $('body, .overlay'),
    $subSubEls: $('.sub-el.sub-sub '),
    $roadmapSliderBtns: $('.fake .swiper-button'),
    $mobileFiltersBtn: $('.js-toggle-filters'),
    $closeMobileFiltersBtn: $('.js-close-filters'),
    $closePopupAccount: $('.close-pop'),
    $closePopupUser: $('.custom-pop.user-pop'),
  }

  const {
    $mobileSelectors,
    $closeMobileFiltersBtn,
    $mobileFiltersBtn,
    $roadmapSliderBtns,
    $subSubEls,
    $globalOverlay,
    $bodyAndOverlay,
    $passIcon,
    $userDropdownBtn,
    $userDropdown,
    $header,
    $bodyGlobal,
    $customCheckboxInput,
    $fileOverlay,
    $fileOverlayBtn,
    $fileOverlayNum,
    $filesPopBtn,
    $filesPop,
    $filesPopInputs,
    $filesPopCheckAllBtn,
    $filesPopDownloadBtn,
    $subMega,
    $jsMedia,
    $userInfoPopBtn,
    $userNewPopBtn,
    $userInfoPop,
    $userNewPop,
    $userNewPasspBtn,
    $userNewPass,
    $relatedSlider,
    $closePopupAccount,
    $closePopupUser,
  } = global_selectors;

  const moreGlobalSelectors = {
    $clientSubnav: $('.sub-subnav'),
    $clientSubSubnav: $('.sub-subnav .sub-nav'),
  }

  const { $clientSubnav,$clientSubSubnav} = moreGlobalSelectors;

  const filters = {
    $customSelects: $('.games-listing-elements .select2-selects'),
    $customSelectsPop: $('.mobile-filter-pop .select2-selects'),
    $orderGamesList: $('.filters-row .right .img-wrapper:not(.reset)'),
    $gamesListingRow: $('.filtered-listing-games-wrapper .row-listing'),
    $resetFilter: $('.js-reset-filter'),
    $clientMobileFiltersPop: $('.mobile-filter-pop '),
    // $clientMobileToggleGameInfo: '.game-listing-box .mobile-toggle',
    $typeGameFilter: $('.custom-tab .top'),
    $typeGameFilterData: $('.custom-tab .drop li'),
    $mobileFiltersPop: $('.mobile-filter-pop'),
  }

  const {
    $customSelects,
    $customSelectsPop,
    $orderGamesList,
    $gamesListingRow,
    $resetFilter,
    $clientMobileFiltersPop,
    // $clientMobileToggleGameInfo,
    $typeGameFilter,
    $typeGameFilterData,
    $mobileFiltersPop,
  } = filters;

  const sliders = {
    $extraFeatures: '.swiper-jackpot-features',
    $extraButtons: $('.images-listing .swiper-button'),
  }

  const {$extraFeatures,$extraButtons} = sliders;

  const latestChanges = {
    $mobileGamesFilter: $('.expand-filter'),
    $clientsFilterDeleteBtn: $('.delete-client'),
    $clientsFilterPop: $('.delete-user-pop'),
  }

  const {$mobileGamesFilter,$clientsFilterDeleteBtn,$clientsFilterPop} = latestChanges;

  /*
   * EVENTS
   */

  function showPass(el) {
    el.each(function () {
      $(this).on('click', function() {
        $(this).toggleClass('flipped');
        let currentInput = $(this).next();
        let currentType = currentInput.attr('type');
        currentType == 'password' ? currentInput.prop('type', 'text') : currentInput.prop('type', 'password') ;
      })
    })
  }

  function toggleUserDropdown(dBtn,dropdown) {
    dBtn.on('click', function() {
      $header.removeClass('mega');
      $(this).toggleClass('active');
      dropdown.toggleClass('active');
      $mobileSelectors.removeClass('active');
      $('.mobile-nav .ul').removeClass('visible');
      $mobileFiltersPop.removeClass('active');
    })
  }

  function triggerGrid(el,row) {
    el.on('click', function()  {
      let data = $(this).attr('data-order');
      el.not($(this)).removeClass('current');
      $(this).addClass('current');
      if (data === 'list') {
        row.removeClass('thumb')
        row.addClass(`${data}`);
      } else {
        row.removeClass('list')
        row.addClass(`${data}`);
      }
    })
  }

  // Function to handle resize event
  function handleResizeGameLibrary() {
    // Get the current screen width
    var screenWidth = window.innerWidth;

    // Check if the screen width is smaller than 820px
    if (screenWidth < 820) {
        // Remove session storage
        $('.main-games-ch').removeClass('list');
        $('.js-order-list').removeClass('current');
        $('.js-order-thumb').addClass('current');
    } else {
      if (sessionStorage.getItem('grid_filter') !== null) {
        $('.main-games-ch').addClass('list');
        $('.js-order-list').addClass('current');
        $('.js-order-thumb').removeClass('current');
      }
    }
  }

  // Add event listener for the resize event
  window.addEventListener('resize', function() {
    handleResizeGameLibrary();
  });

  function resetFilter(el) {
    el.on('click', function() {
      location.reload()
    })
  }

  function loopFiles(elements, size = false) {
    let cLength = [];
    if (size) {
        elements.each(function() {
            let sizeText = $(this).next().find('span').text().trim();
            let sizeValue = parseFloat(sizeText);
            if (sizeText.includes("Mb")) {
                sizeValue *= 1024 * 1024; // Convert Mb to Bytes
            } else if (sizeText.includes("Kb")) {
                sizeValue *= 1024; // Convert Kb to Bytes
            }
            if ($(this).is(':checked')) {
                cLength.push(sizeValue);
            }
        });
    } else {
        elements.each(function() {
            if ($(this).is(':checked')) {
              let id = $(this).attr('id');
              let number = id.split('-')[0];
                cLength.push(number);
            }
        });
    }

    return cLength;
}

  function megaMenuEach(element) {
    element.each(function () {
      let innerLabel = $('.sub-el.sub-sub .p');
      let innerNav = $('.sub-el.sub-sub ul');
      $(this).on('click', function () {
        $(this).find('.p').toggleClass('open');
        $(this).find('ul').slideToggle();
        innerLabel.not($(this).find('.p')).removeClass('open');
        innerNav.not($(this).find('ul')).slideUp();
        if(innerLabel.hasClass('open')) {
          $header.addClass('casino');
        } else {
          $header.removeClass('casino');
        }
      })
    })
  }

  function popUpElements(btn,global,popup) {
    btn && btn.on('click',function(){
      global.addClass('active');
      popup.find('.data').find('.filter-wrapper-ch').removeClass('active');
      popup.find('.data').find('.filter-wrapper-ch input').val('')
      popup.find('.data').find('span:not(.pop-up-profile-info)').remove()
      popup.addClass('active');
      $('#header + .user-dropdown,#header .profile').removeClass('active');
    });
  }

  function popUpDeleteClients(btn,global,popup) {
    btn.each(function () {
      $(this) && $(this).on('click',function(){
        let id = $(this).attr('data-client-id');
        global.addClass('active');
        popup.addClass('active');
        popup.find('.ch-ajax-client-delete').attr('data-client-id',id)
        $('#header + .user-dropdown,#header .profile').removeClass('active');
      });
    })
  }

  function filesPopCheckAll() {
    if($(this).is(':checked')) {
      $filesPopInputs.prop( 'checked', true );
      $('.over, .over .c-btn').removeClass('disabled')
    } else {
      $filesPopInputs.prop( 'checked', false );
      $('.over, .over .c-btn').addClass('disabled')
    }
  }


  function checkBoxLogic() {
    let checkedElements = $('.accordion .styled-checkbox:checked');
    let elements = $(this).parents().eq(3).find('input'),
      length = loopFiles(checkedElements).length,
      sizes = sumArray( loopFiles(checkedElements,true));
    if(length > 1) {
      $('.over, .over .c-btn').removeClass('disabled')
    }else {
      $('.over, .over .c-btn').addClass('disabled')
    }
    if(length > 1) {
      let sum = formatBytes(sizes)
      $fileOverlay.addClass('active');
      $fileOverlayNum.text(length);
      $('.custom-file-overlay .size').text(sum);
    } else {
      $fileOverlay.removeClass('active');
    }
  }

  //START ACCORDIONS AND CHECKBOX LOGIC

  function loadFAQAAccordions() {
  if ($('body').hasClass('client-document')) {
      $('.accordion-title').click(function() {
        var icon = $(this).find('.accordion-icon');
        var content = $(this).next('.accordion-content');
        
        // Toggle active class to trigger the animation
        content.toggleClass('active');
        icon.text(icon.text() == '+' ? '-' : '+');
      });
    }
   }
  loadFAQAAccordions();

  function useSelect2ForResourcesPage() {
    $('#slot_filter, #market_filter, #label_filter, #jackpot_filter').select2();
  
    // Get the text of the first option for slot_filter
    var defaultOptionTextSlot = $('#slot_filter option:first-child').text();

    // Get the text of the first option for market_filter
    var defaultOptionTextMarket = $('#market_filter option:first-child').text();
    
    // Get the text of the first option for label_filter
    var defaultOptionTextLabel = $('#label_filter option:first-child').text();

    // Get the text of the first option for jackpot_filter
    var defaultOptionTextJackpot= $('#jackpot_filter option:first-child').text();

    // Set the text of the select dropdown for market_filter
    $('#slot_filter').siblings('.select2').find('#select2-slot_filter-container').text(defaultOptionTextSlot);

    // Set the text of the select dropdown for market_filter
    $('#market_filter').siblings('.select2').find('#select2-market_filter-container').text(defaultOptionTextMarket);

    // Set the text of the select dropdown for label_filter
    $('#label_filter').siblings('.select2').find('#select2-label_filter-container').text(defaultOptionTextLabel);
    
    // Set the text of the select dropdown for jackpot_filter
    $('#jackpot_filter').siblings('.select2').find('#select2-jackpot_filter-container').text(defaultOptionTextJackpot);
  }
  // Call the function when the document is ready
  useSelect2ForResourcesPage();
 

  // Select all, Unselect All span - change according the state
  function onClickMarkCurrentCheckboxes() {
    $(document).on('click', '.checkboxes_select', function() {
        var $checkboxesSelect = $(this);
        var $currentSection = $checkboxesSelect.closest('.current_section');
        var $styledCheckboxes = $currentSection.find('.styled-checkbox');
        var $singleMaterialRows = $currentSection.find('.single-material-row');

        $styledCheckboxes.prop('checked', !$checkboxesSelect.hasClass('active'));
        $checkboxesSelect.toggleClass('active');

        if ($checkboxesSelect.hasClass('active')) {
            $checkboxesSelect.text('Unselect');
            $singleMaterialRows .addClass('selected');
        } else {
            $checkboxesSelect.text('Select All');
            $singleMaterialRows.removeClass('selected');
        }

        checkBoxLogic();
    });
}

// Select all, Unselect All span - change according the state of the checkboxes
function checkAndUpdateCustomCheckbox() {
  $(document).on('click', '.custom-checkbox', function() {
      var $checkbox = $(this);
      var $currentSection = $checkbox.closest('.current_section');
      var $checkboxesSelect = $currentSection.find('.checkboxes_select');
      var $styledCheckboxes = $currentSection.find('.styled-checkbox');

      var allChecked = true;
      var anyUnchecked = false;

      // Check if all checkboxes are checked or any are unchecked
      // Check if all checkboxes within the filtered data are checked or any are unchecked
        $styledCheckboxes.each(function() {
          if (!$(this).prop('checked')) {
              anyUnchecked = true;
          } else {
              // If any checkbox is checked, set the flag to true
              allChecked = true;
          }
        });

      // Update button text and add/remove active class based on checkbox state
      if (anyUnchecked || !allChecked) {
          $checkboxesSelect.removeClass('active');
          $checkboxesSelect.text('Select All');
      } else {
          $checkboxesSelect.addClass('active');
          $checkboxesSelect.text('Unselect');
      }
  });
}

checkAndUpdateCustomCheckbox();

// Filter according the selected choices via data-attributes
if ($('body').hasClass('client-branding')) {
  // Function to filter accordion elements based on selected values and search input
  function filterAccordion() {
    var selectedTypeGame = $('#slot_filter').val();
    var selectedLabel = $('#label_filter').val();
    var selectedCountry = $('#market_filter').val();
    var selectedJackpot = $('#jackpot_filter').val();
    var searchField = $('#search_input').val().toLowerCase(); // Get the value of the search input field

    var visibleCount = 0;

    $('.accordion').each(function() {
      var accordion = $(this);
      var label = accordion.data('label');
      var type_game = accordion.data('typegame');
      var slugs = accordion.data('slugs');
      var jackpot = accordion.data('jackpot');
      var title = accordion.find('.accordion-title h1').text().toLowerCase(); // Get the text of the accordion title

      if ((selectedTypeGame === 'all_games' || selectedTypeGame === 'none' || selectedTypeGame == null || type_game == selectedTypeGame) &&
        (selectedJackpot === 'all' || selectedJackpot === 'none' || selectedJackpot == null || jackpot == selectedJackpot) &&
        (selectedLabel === 'all' || selectedLabel === 'none' || selectedLabel == null || label === selectedLabel) &&
        (selectedCountry === 'all' || selectedCountry === 'none' || selectedCountry == null || $.inArray(selectedCountry, slugs) !== -1) && slugs.length > 0) {
        
        // Check if the accordion title matches the search input
        if (title.indexOf(searchField) !== -1) {
          accordion.addClass('filtred');
          visibleCount++;
        } else {
          accordion.removeClass('filtred');
        }
      } else {
        accordion.removeClass('filtred');
      }
    });

    // Show message if no accordion elements are visible
    if (visibleCount === 0) {
      $('.checkbox_select_all').hide();
      $('.cl-section.brand-materials .branding-filter').css('justify-content', 'flex-end');
      $('#no_results_message').show();
    } else {
      $('.checkbox_select_all').show();
      $('.cl-section.brand-materials .branding-filter').css('justify-content', 'space-between');
      $('#no_results_message').hide();
    }
    updateAccordionTitles();
  }

  // Add an event listener for the keyup event on the search input field
  $('#search_input').on('keyup', function() {
    filterAccordion(); // Trigger the filtering function on keyup
    resetCheckboxes();
  });

  // Function to update accordion titles based on selected country
  function updateAccordionTitles() {
    var selectedCountry = $('#market_filter').val();
    var firstVisibleAccordion = null; // Track the first visible filtered accordion
    // Iterate over each accordion
    $('.accordion').each(function() {
      var accordion = $(this);
      var newForCountries = accordion.data('newfor');
      var slugs = accordion.data('slugs');
      var titleTop = accordion.find('.accordion-title .top');

      // Check if the accordion meets the filter conditions and is visible
      if (newForCountries && accordion.hasClass('filtred') && newForCountries.includes(selectedCountry) && slugs.includes(selectedCountry)) {
        // Check if the "NEW" element already exists in the title
        if (titleTop.find('.element-badge').length === 0) {
          // Append the desired element to the title
          titleTop.prepend('<h1 class="element-badge">NEW</h1>');
        }
        // Store the first visible filtered accordion
        if (!firstVisibleAccordion) {
          firstVisibleAccordion = accordion;
        }
      } else {
        // Remove the "NEW" element from the title if it exists
        titleTop.find('.element-badge').remove();
      }
    });

    // Ensure the visibility of the first visible filtered accordion
    if (firstVisibleAccordion) {
      firstVisibleAccordion.show();
    }
  }

  // Trigger filterAccordion function when dropdowns change
  $('#slot_filter, #label_filter, #market_filter, #jackpot_filter').change(function() {
    resetCheckboxes();
    filterAccordion();
  });

  // Initially filter the accordion elements based on default values
  filterAccordion();
}

  function toggleSelectAllCheckboxes() {

    // Update the text of the "Select All" span within the current accordion
    var $checkboxesSelect = $('.accordion.filtred .current_section .checkboxes_select');
    var $styledCheckboxes = $('.accordion.filtred .current_section .styled-checkbox');

    var allChecked = true;
    var anyUnchecked = false;

    // Check if all checkboxes are checked or any are unchecked
    $styledCheckboxes.each(function() {
        if (!$(this).prop('checked')) {
            allChecked = false;
            anyUnchecked = true;
            return false; // Exit loop early
        }
    });

    // Update button text and add/remove active class based on checkbox state
    if (anyUnchecked || !allChecked) {
        $checkboxesSelect.removeClass('active');
        $checkboxesSelect.text('Select All');
    } else {
        $checkboxesSelect.addClass('active');
        $checkboxesSelect.text('Unselect');
    }
}
  
    // Function to toggle all checkboxes in the current section and update the "Select All Items" span text
  function toggleCheckboxesAndUpdateSpan() {
    var $sectionCheckboxes = $('.detect-accordion .accordion.filtred .current_section .styled-checkbox');
    var $selectAllItemsSpan = $('.checkbox_select_all label');

    var allChecked = true;
    var anyUnchecked = false;

    // Check if any checkboxes are unchecked
    $sectionCheckboxes.each(function() {
        if (!$(this).prop('checked')) {
            allChecked = false;
            anyUnchecked = true;
            return false; // Exit the loop early if any checkbox is unchecked
        }
    });

    // If any checkboxes are unchecked, select all
    if (!allChecked && anyUnchecked) {
        $sectionCheckboxes.prop('checked', true);
        $selectAllItemsSpan.text('Unselect All Items');
        $('.detect-accordion .checkbox_select_all input').prop('checked', true);
        $('.single-material-row').addClass('selected');
    } else {
        // Otherwise, unselect all
        $sectionCheckboxes.prop('checked', false);
        $selectAllItemsSpan.text('Select All Items');
        $('.detect-accordion .checkbox_select_all input').prop('checked', false);
        $('.single-material-row').removeClass('selected');
    }

    // Perform any additional logic here
    checkBoxLogic();
  }

  
  // Event handler for click on "Select All Items" span
  $(document).on('click', '.all_checkboxes', function() {
    toggleCheckboxesAndUpdateSpan();
  });

  // Function to update the text of the "Select All Items" span based on checkbox state
  function updateSelectAllItemsSpan() {
    var $sectionCheckboxes = $('.accordion.filtred .current_section .styled-checkbox');
    var $selectAllItemsSpan = $('.checkbox_select_all label');

    var allChecked = true;

    // Check if any checkboxes are unchecked
    $sectionCheckboxes.each(function() {
        if (!$(this).prop('checked')) {
            allChecked = false;
            return false; // Exit the loop early if any checkbox is unchecked
        }
    });

    // Update the text of the "Select All Items" span based on checkbox state
    if (!allChecked) {
        $selectAllItemsSpan.text('Select All Items');
        $('.checkbox_select_all input').prop('checked', false);
    } else {
        $selectAllItemsSpan.text('Unselect All Items');
        $('.checkbox_select_all input').prop('checked', true);
    }       
     checkBoxLogic();
  }
  // Event handler for click on individual checkbox
  $(document).on('click', '.accordion.filtred .current_section .styled-checkbox', function() {
    updateSelectAllItemsSpan();
  });

  //Logic and fix to reset all checkboxes on change of dropdown
  function resetCheckboxes() {
    $('.current_section .styled-checkbox').prop('checked', false);
    $('.checkboxes_select').text('Select All').removeClass('active');
    $('.custom-file-overlay').removeClass('active');
    $('.single-material-row').removeClass('selected');
    $('.detect-accordion .checkbox_select_all label').text('Select All Items');
    $('.detect-accordion .checkbox_select_all input').prop('checked', false);
  }

  // Event handler for the click event on the "Select All Items" span
  $('.all_checkboxes').click(function() {
    toggleSelectAllCheckboxes();
  });

  // Add selected class to the row depending the state
  function handleCheckboxSelection() {
    // Event handler for checkboxes
    $('.brand-documents .styled-checkbox').on('click', function() {
        // Get the parent row of the checkbox
        var $row = $(this).closest('.single-material-row');
        
        // Toggle the 'selected' class based on the checkbox state
        if ($(this).prop('checked')) {
            $row.addClass('selected');
        } else {
            $row.removeClass('selected');
        }
    });
  }
  handleCheckboxSelection();
  //END ACCORDIONS AND CHECKBOX LOGIC

  function globalFilesDownload(btn,exElements,extra=false) {
    btn && btn.on('click', function() {
      extra && $filesPopInputs.prop( 'checked', true );
      let elements = exElements,
        result = loopFiles(elements);
      promptFileDownload(result);
      $filesPop.removeClass('active');
    });
  }

  function removeHidden() {
    $closePopupUser.removeClass('active');
    $bodyAndOverlay.removeClass('active'); 
  }

  function mobileNavNesting() {
    $(this).on('click', function(){
      let tab = $(this).attr('data-sub');
      $clientSubnav.addClass('open');
      $clientSubSubnav.removeClass('open');
      $(`.sub-subnav .sub-nav[data-sub = ${tab}]`).addClass('open');
    })
  }

  function roadmapFakeBtnsLogic() {
    let current = $(this)[0].className;
    $extraButtons.each(function() {
      let logic = $(this)[0].className == current;
      logic && $(this).trigger('click');
    })
  }


  function toggleMobileFilters() {
    $header.addClass('filter');
    $('#header .profile, #header + .user-dropdown').removeClass('active')
    if($header.hasClass('sticky')) {
      $clientMobileFiltersPop.addClass('sticky');
    }else {
      $clientMobileFiltersPop.removeClass('sticky');
    }
  }

  function closeMobileFilters() {
    location.reload();
  }

  function filterJackpotCategory(top,els) {
    toggleSelect(top,els);
    $(document).mouseup(function(e) {
      var container = top.parent();
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0){
        top.removeClass('open');
        top.next().slideUp(0);
      }
    });
  }

  function expandMobileFilter() {
    $mobileFiltersPop.toggleClass('expand');
  }
  function fireSelectors(){
    $(window).width() < 1025 ? searchBar( $customSelectsPop) : searchBar($customSelects) ;
  }

  // function toggleMobileGameInfo() {
  //   $(this).toggleClass('open');
  //   $(this).prev().find('.details').slideToggle();
  //   $(this).prev().find('.bottom').slideToggle()
  // }

  /*
   * ACTIONS
   */

  triggerGrid($orderGamesList,$gamesListingRow);
  showPass($passIcon);
  toggleUserDropdown($userDropdownBtn,$userDropdown);
  resetFilter($resetFilter);
  megaMenuEach($subMega);
  popUpElements($filesPopBtn,$bodyGlobal,$filesPop);
  popUpElements($userInfoPopBtn,$bodyGlobal,$userInfoPop);
  popUpElements($userNewPopBtn,$bodyGlobal,$userNewPop);
  popUpElements($userNewPasspBtn,$bodyGlobal,$userNewPass);
  globalFilesDownload($filesPopDownloadBtn,$filesPopInputs);
  globalFilesDownload($jsMedia,$filesPopInputs,true);
  globalFilesDownload($fileOverlayBtn,$customCheckboxInput);
  popUpDeleteClients($clientsFilterDeleteBtn,$bodyGlobal,$clientsFilterPop);
  $filesPopCheckAllBtn.on('click', filesPopCheckAll);
  $customCheckboxInput.on('click', checkBoxLogic);
  onClickMarkCurrentCheckboxes();
  checkAndUpdateCustomCheckbox();
  //$globalOverlay.on('click',removeHidden);
  $closePopupAccount.on('click',removeHidden);



  $subSubEls.each(mobileNavNesting);
  $roadmapSliderBtns.on('click', roadmapFakeBtnsLogic);
  $mobileFiltersBtn.on('click', toggleMobileFilters);
  $closeMobileFiltersBtn.on('click', closeMobileFilters);
  // $(document).on('click', $clientMobileToggleGameInfo, toggleMobileGameInfo);
  filterJackpotCategory($typeGameFilter,$typeGameFilterData);
  $mobileGamesFilter.on('click',expandMobileFilter);
  fireSelectors();
  $(window).on('resize', function() {
      fireSelectors();
      //location.reload();
      // if (window.innerWidth > window.innerHeight) {
      //   if (sessionStorage.getItem("grid_filter") === null && document.documentElement.clientWidth > 767 || matchMedia('only screen and (max-width: 1025px) and (orientation:landscape)').matches) {
      //     $('.row-listing').addClass('list landscape');
      //   } else {
      //     $('.row-listing').addClass('landscape');
      //   }
      // } else {
      //   if (matchMedia('only screen and (max-width: 767px)').matches) {
      //     $('.row-listing').removeClass('list landscape');
      //   } else {
      //     $('.row-listing').removeClass('landscape');
      //   }
      // }
  });
  /*
 * EXTRA EXPORTS
 */

  generateSlider($extraFeatures,extraFeatSettings);
  generateSlider($relatedSlider,relatedGamesSettings);
}

export default clientHubLogic;


// WEBPACK FOOTER //
// ./scripts/components/clientEvents.js